import {
  SERVICE_ACTION_CALL_STATUS,
  SERVICE_ACTION,
  JOB_STATUS,
} from "./ServiceConstants";

// Determine which document the service is being created against.
export const getActiveDocument = (erfData) => {
  const docNr = erfData?.documentNumber || "";
  const isExtension = docNr.startsWith("EX") || docNr.includes("ERFEXT");
  return {
    activeDocumentNr: docNr,
    activeDocumentType: isExtension ? "Extension" : "ERF",
    rootErfNr: erfData?.equipmentNr || erfData?.documentNumber,
    parentExtNr: erfData?.equipmentExtNr || null,
  };
};

// pcCallStatus right after service creation.
export const computePcCallStatusOnCreate = (serviceRequiredItems) => {
  const hasReplacement = serviceRequiredItems.some(
    (i) => i.serviceAction === SERVICE_ACTION.REPLACEMENT,
  );
  return hasReplacement
    ? SERVICE_ACTION_CALL_STATUS.ASSIGN_TO_STORE
    : SERVICE_ACTION_CALL_STATUS.SERVICE_ASSIGNED;
};

// Build serviceRequiredItems array — only items the dispatcher selected.
export const buildServiceRequiredItems = (rentItems) =>
  rentItems
    .filter(
      (item) =>
        item.serviceAction &&
        item.serviceAction !== "" &&
        item.serviceAction !== "Select",
    )
    .map((item) => ({
      lineItemId: item.local_id || item.lineItemId || item._id,
      equipmentItemNr: item.equipmentItemNr,
      materialCode: item.materialCode,
      materialDescription: item.materialDescription,
      currentBarcode: item.barcode || "",
      itemType: item.itemType || "Rent",
      serviceAction: item.serviceAction,
      newBarcode: "",
      barcodeAssigned: false,
      barcodeAssignedAt: null,
      barcodeAssignedBy: null,
      barcodeReceivedBySE: "",
      returnedBarcode: "",
      returnedToStore: false,
      replacementComplete: false,

      hsnCode: item.hsnCode || "",
      orderedQuantity: item.orderedQuantity || 1,
      orderUnitOfMeasure: item.orderUnitOfMeasure || "Unit",
      brand: item.brand || "",
      materialGroup: item.materialGroup || "",
      materialSubCategory: item.materialSubCategory || "",
    }));

// Append replacement entry to a rent item's local replacement log.
// Per-document log — never copied across ERF / extension docs.
export const appendReplacementLog = (
  rentItem,
  oldBarcode,
  newBarcode,
  serviceNr,
  userId,
) => {
  const log = rentItem.barcodeReplacementLog || [];
  return {
    ...rentItem,
    barcode: newBarcode,
    previousBarcode: oldBarcode,
    barcodeReplacementLog: [
      ...log,
      {
        seq: log.length + 1,
        oldBarcode,
        newBarcode,
        serviceNr,
        replacedAt: new Date().toISOString(),
        replacedBy: userId,
      },
    ],
  };
};

// Build a SE entry — same shape used by AssignToDispatchModel.
// No duplicate seName/seUserId — only the ERF-standard keys.
export const buildSeAssignment = (
  selectedSeData,
  category,
  description,
  existingCount,
  currentUser,
) => ({
  version: `v${(existingCount || 0) + 1}`,
  serviceProviderCode: selectedSeData.userId,
  serviceProviderUserId: selectedSeData.userId,
  serviceProviderName: selectedSeData.firstName || selectedSeData.name || "",
  assignDateAndTime: new Date().toISOString(),
  assignedBy: currentUser?.userId || "",
  serviceAssignCategory: category || "Service",
  serviceAssignCategoryDescription: description || "",
  jobStatus: JOB_STATUS.PENDING,
  jobStatusRemarks: "",
});

export const hasRole = (roles, roleId) =>
  Array.isArray(roles) && roles.some((r) => r.roleId === roleId);
